import { render, staticRenderFns } from "./NIPData.vue?vue&type=template&id=6e621206&scoped=true"
import script from "./NIPData.vue?vue&type=script&lang=js"
export * from "./NIPData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e621206",
  null
  
)

export default component.exports